export default {
  topPanel: {
    title: '本月采购申请情况',
    quarter: '环比',
    paneList: {
      totalRequest: '总申请数（次）',
      suppliers: '供应商数量（个）',
      productCategory: '采购商品品类（类）',
      applicant: '申请人数量（人）',
      completionRate: '申请完成率（%）',
      arrivalRate: '到货及时率（%）',
    },
  },
  procurement: {
    title: '采购商品申请趋势',
    goods: {
      cup: '杯子',
      tea: '茶叶',
      honey: '蜂蜜',
      flour: '面粉',
      coffeeMachine: '咖啡机',
      massageMachine: '按摩仪',
    },
  },
  ssl: 'SSL证书',
  sslDescription:
    'SSL证书又叫服务器证书，北京亿加缘运动科技有限公司为您提供证书的一站式服务，包括免费、付费证书的申请、管理及部署',
  satisfaction: {
    title: '采购商品满意度分布',
    export: '导出数据',
  },
  chart: {
    week1: '周一',
    week2: '周二',
    week3: '周三',
    week4: '周四',
    week5: '周五',
    week6: '周六',
    week7: '周日',
    max: '最大值',
    min: '最小值',
    thisMonth: '本月',
    lastMonth: '上月',
  },
};
